import ProductFilter from "./product-filter";
import Accordion from "./accordion/accordion";
import Filter from "./profilter/filter";
import AutoComplete from '@tarekraafat/autocomplete.js';

function main(): void {
  /*const courseOverviewElement = document.querySelector("section.course");
  if (!courseOverviewElement) {
    return;
  }*/


  let sectionWidthFilter =  document.querySelector('.with-filter');

  if(sectionWidthFilter != null){
  new Filter();
  new Accordion();
  }

  /*const productFilter = new ProductFilter(courseOverviewElement);
  productFilter.init();

  const titles: string[] = productFilter.titles.toArray();
  const productFilterSearch = document.querySelector('#product-filter-search') as HTMLInputElement;
  
  new AutoComplete({
    data: {
      src: titles,
      cache: true
    },
    selector: '#product-filter-search',
    threshold: 3,
    debounce: 300,
    searchEngine: "loose",
    highlight: true,
    resultsList: {
      render: true,
      destination: productFilterSearch,
      position: 'afterend'
    },
    resultItem: {
      content: (data, source) => {
        source.innerHTML = data.match;
      }
    },
    onSelection: (feedback) => {
      productFilterSearch.value = feedback.selection.value;
    }
  });
*/

}

document.addEventListener("DOMContentLoaded", main);
